export const getNavigatorLocale = () => {
    return navigator.language || 'en-US';
};

export const enUS = 'en-US';
export const esUS = 'es-US';
export const en = 'en';
export const es = 'es';
export const availableLanguages = [enUS, esUS, en, es];
